<template>
    <div class="chart-wrapper" id="chart">
        <zm-dropdown @command="handleCommand" style="float: right" trigger="click">
            <zm-button type="icon" icon="zm-icon-more" style="z-index: 2001" :loading="deleteLoading"></zm-button>
            <zm-dropdown-menu slot="dropdown">
                <zm-dropdown-item command="editCard" v-if="groupName">Edit Card</zm-dropdown-item>
                <zm-dropdown-item command="deleteCard">Delete Card</zm-dropdown-item>
            </zm-dropdown-menu>
        </zm-dropdown>
        <ve-line :data="chartData" :extend="chartExtend" width="99%" height="calc(100% - 30px)" :settings="chartSettings"
            :legend-visible="true" :events="chartEvents" ref="chart" :legend="chartExtend.legend" v-loading="loading"></ve-line>
    </div>
</template>
<script>
import { getMetricsDataForMetricsCard, deleteMetricsCard, getMetricsCardDetail } from '@/api/manageDashboard'
import _ from 'lodash'
export default {
    name: 'cardChart',
    props: ['active', 'groupName', 'step', 'stepUnit', 'cardId', 'startTime', 'endTime', 'timeZone'],
    data () {
        var _this = this
        return {
            loading: false,
            deleteLoading: false,
            chartData: {
                columns: ['time'],
                rows: []
            },
            chartSettings: {
                yAxisName: ['']
            },
            interval: null,
            chartEvents: {
                click: function (e) {
                    _this.chartExtend.legend.selected = {}
                    if (!_this.isSelected || (_this.isSelected && _this.isSelected !== e.seriesName)) {
                        _this.isSelected = e.seriesName
                        _this.chartExtend.legend.data.map(item => {
                            if (item === e.seriesName) {
                                _this.chartExtend.legend.selected[item] = true
                            } else {
                                _this.chartExtend.legend.selected[item] = false
                            }
                        })
                    } else {
                        _this.isSelected = ''
                        _this.chartExtend.legend.data.map(item => {
                            _this.chartExtend.legend.selected[item] = true
                        })
                    }
                },
                legendselectchanged: function (e) {
                    _this.chartExtend.legend.selected = {}
                    if (!_this.isSelected || (_this.isSelected && _this.isSelected !== e.name)) {
                        _this.isSelected = e.name
                        _this.chartExtend.legend.data.map(item => {
                            if (item === e.name) {
                                _this.chartExtend.legend.selected[item] = true
                            } else {
                                _this.chartExtend.legend.selected[item] = false
                            }
                        })
                    } else {
                        _this.isSelected = ''
                        _this.chartExtend.legend.data.map(item => {
                            _this.chartExtend.legend.selected[item] = true
                        })
                    }
                },
                legendScroll: function (e) {
                    _this.chartExtend.legend.scrollDataIndex = e.scrollDataIndex
                }
            },
            chartExtend: {
                title: {
                    text: ''
                },
                // yAxis: {
                //     name: '',
                //     type: 'value'
                // },
                legend: {
                    type: 'scroll',
                    // orient: 'vertical',
                    right: 20,
                    top: 30,
                    // bottom: 20,
                    data: [],
                    selected: {}
                },
                grid: {
                    top: 70,
                    bottom: 15,
                    containLabel: true
                },
                series: {
                    type: 'line',
                    smooth: false
                },
                tooltip: {
                    formatter: function (params) {
                        var str = params[0].axisValue
                        params.map(param => {
                            var arr = ''
                            for (var i = 0; i < param.seriesName.length / 70; i++) {
                                arr += (i >= (param.seriesName.length / 70) - 1 ? param.seriesName.slice(i * 70, (i + 1) * 70) : param.seriesName.slice(i * 70, (i + 1) * 70) + '<br />')
                            }
                            str += '<br />' + arr + ':' + param.value[1]
                        })
                        return str
                    }
                }
            }
        }
    },
    created () {
        this.getCardName()
        if (this.active) {
            this.fetchData()
        }
    },
    beforeDestroy () {
        clearInterval(this.interval)
    },
    watch: {
        active () {
            this.fetchData()
        },
        startTime () {
            this.fetchData()
        },
        endTime () {
            this.fetchData()
        },
        timeZone () {
            this.fetchData()
        },
        step () {
            this.debounceFetchData()
        },
        stepUnit () {
            this.fetchData()
        }
    },
    methods: {
        refreshData (duration) {
            this.fetchData()
            clearInterval(this.interval)
            var that = this
            this.interval = setInterval(function () {
                that.fetchData()
            }, duration * 1000)
        },
        stopRefresh () {
            clearInterval(this.interval)
        },
        debounceFetchData: _.debounce(function () {
            this.fetchData()
        }, 1000),
        fetchData () {
            const data = {
                step: this.step,
                stepUnit: this.stepUnit,
                metricsCardId: this.cardId,
                startTime: this.startTime,
                endTime: this.endTime
            }
            this.loading = true
            getMetricsDataForMetricsCard(data).then(response => {
                this.loading = false
                this.chartData.columns = ['time']
                this.chartData.rows = []
                this.chartExtend.legend.data = []
                this.chartExtend.legend.selected = {}
                if (response.data.result.length) {
                    response.data.result[0].values.map(value => {
                        const time = new Date(value[0]).getTime() + this.timeZone * 60 * 60 * 1000
                        this.chartData.rows.push({
                            time: new Date(time).getUTCFullYear() + '-' + (new Date(time).getUTCMonth() + 1) + '-' + new Date(time).getUTCDate() + ' ' + new Date(time).getUTCHours() + ':' + new Date(time).getUTCMinutes() + ':' + new Date(time).getUTCSeconds()
                        })
                    })
                    response.data.result.map(result => {
                        result.columns.map((column, index) => {
                            if (column !== 'time') {
                                const str = column + '(' + JSON.stringify(result.metric) + ')'
                                if (this.metricSelected && !this.columnSelected) {
                                    if (JSON.stringify(result.metric) === this.metricSelected) {
                                        this.chartData.columns.push(str)
                                        this.chartExtend.legend.data.push(str)
                                        this.chartExtend.legend.selected[str] = true
                                        result.values.map((value, valueIndex) => {
                                            this.chartData.rows[valueIndex][str] = value[index]
                                        })
                                    }
                                } else if (this.metricSelected && this.columnSelected) {
                                    if (JSON.stringify(result.metric) === this.metricSelected && column === this.columnSelected) {
                                        this.chartData.columns.push(str)
                                        this.chartExtend.legend.data.push(str)
                                        this.chartExtend.legend.selected[str] = true
                                        result.values.map((value, valueIndex) => {
                                            this.chartData.rows[valueIndex][str] = value[index]
                                        })
                                    }
                                } else if (!this.metricSelected && this.columnSelected) {
                                    if (column === this.columnSelected) {
                                        this.chartData.columns.push(str)
                                        this.chartExtend.legend.data.push(str)
                                        this.chartExtend.legend.selected[str] = true
                                        result.values.map((value, valueIndex) => {
                                            this.chartData.rows[valueIndex][str] = value[index]
                                        })
                                    }
                                } else {
                                    this.chartData.columns.push(str)
                                    this.chartExtend.legend.data.push(str)
                                    this.chartExtend.legend.selected[str] = true
                                    result.values.map((value, valueIndex) => {
                                        this.chartData.rows[valueIndex][str] = value[index]
                                    })
                                }
                            }
                        })
                    })
                    if (this.chartData.rows.length) {
                        this.chartSettings.yAxisName[0] = this.metricsName.unit
                    }
                }
                this.$nextTick(() => {
                    this.chart = this.$refs.chart.echarts
                })
            }).catch(() => {
                this.loading = false
            })
        },
        getCardName () {
            getMetricsCardDetail(this.cardId).then(response => {
                this.chartExtend.title.text = response.name
            })
        },
        editCard () {
            this.$router.push({
                path: '/dashboard/manage/dashboard/card/edit/' + this.cardId,
                query: {
                    group: this.groupName
                }
            })
        },
        deleteCard () {
            this.$confirm('This will delete the card. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.deleteLoading = true
                deleteMetricsCard(this.cardId).then(response => {
                    this.deleteLoading = false
                    this.$message({
                        message: 'Submit delete success!',
                        type: 'success'
                    })
                    this.$emit('deleteMetricsCard')
                }).catch(() => {
                    this.deleteLoading = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        handleCommand (command) {
            if (command === 'editCard') {
                this.editCard()
            } else if (command === 'deleteCard') {
                this.deleteCard()
            }
        }
    }
}
</script>
<style scoped>
.chart-wrapper {
    height: 40vh;
    border: solid 1px rgb(228, 228, 231);
    border-radius: 12px;
    padding: 20px;
    margin: 20px;
    box-shadow: 0 2px 12px 0 #f5f7fa;
}
/* .chart-wrapper:hover {
    box-shadow: 0 2px 12px 0 #0E71EB;
} */
</style>
